import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackTranscriptionEditMode.meta';

export const useTrackTranscriptionEditMode = () => {
  const { track } = useAnalyticsUtilities();

  const trackTranscriptionEditMode = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackTranscriptionEditMode };
};
